"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _syntheticEvent = _interopRequireDefault(require("../../utils/syntheticEvent"));

var _cardRender = _interopRequireDefault(require("./utils/cardRender"));

var _cardSimpleRender = _interopRequireDefault(require("./utils/cardSimpleRender"));

var _dataModel = _interopRequireDefault(require("../../common/backbone/dataModel"));

var _prepareModel = _interopRequireDefault(require("./utils/prepareModel"));

var _prepareObject = _interopRequireDefault(require("./utils/prepareObject"));

var _DropDown = _interopRequireDefault(require("../DropDown"));

var _mergeTheme = _interopRequireDefault(require("../style/mergeTheme"));

var _select = _interopRequireDefault(require("./style/modern/select"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CardSelect = function CardSelect(_ref) {
  var selectFirst = _ref.selectFirst,
      value = _ref.value,
      collection = _ref.collection,
      onChange = _ref.onChange,
      name = _ref.name,
      theme = _ref.theme,
      style = _ref.style,
      render = _ref.render,
      disabled = _ref.disabled,
      simple = _ref.simple,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["selectFirst", "value", "collection", "onChange", "name", "theme", "style", "render", "disabled", "simple"]);
  var optionRender = simple ? _cardSimpleRender["default"] : render;
  (0, _react.useEffect)(function () {
    // cardId can be int 0
    if (selectFirst && (value === null || value === '' || value === undefined)) {
      var list = collection.models || collection,
          _value = list[0] && list[0].id;

      if (_value && typeof onChange === 'function') {
        onChange((0, _syntheticEvent["default"])({
          value: _value,
          type: 'select',
          name: name
        }));
      }
    }
  }, []);
  var content = null;
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme, style);
  }, [style, theme]);

  if (typeof optionRender === 'function') {
    content = collection === null || collection === void 0 ? void 0 : collection.map(function (model) {
      var data = model instanceof _dataModel["default"] ? (0, _prepareModel["default"])({
        model: model,
        theme: simple ? memoTheme.simple : memoTheme,
        disabled: disabled
      }) : (0, _prepareObject["default"])({
        data: model,
        theme: simple ? memoTheme.simple : memoTheme,
        disabled: disabled
      });
      return function (props) {
        return optionRender(_objectSpread({}, data, {}, props));
      };
    });
  }

  var dropDownStyle = (0, _react.useMemo)(function () {
    return simple ? {} : (0, _select["default"])(memoTheme);
  }, [memoTheme, simple]);
  return _react["default"].createElement(_DropDown["default"], (0, _extends2["default"])({}, rest, {
    bind: false,
    disabled: disabled,
    value: value,
    onChange: onChange,
    name: name,
    style: dropDownStyle
  }), content);
};

CardSelect.propTypes = {
  collection: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),

  /**
   * select first card by default
   */
  selectFirst: _propTypes["default"].bool,
  render: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  emptyListPlaceholder: _propTypes["default"].string,
  simple: _propTypes["default"].bool,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default flex
     */
    display: _propTypes["default"].string,

    /**
     * @default palette.tsSmall
     */
    fontSize: _propTypes["default"].string,

    /**
     * @default palette.tlSmall
     */
    lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tFilled
     */
    color: _propTypes["default"].string,

    /**
     * @default palette.tDisabled
     */
    disabledColor: _propTypes["default"].string,

    /**
     * @default palette.tAccent
     */
    selectedColor: _propTypes["default"].string,

    /**
     * @default palette.twNormal
     */
    fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default palette.tsNormal
     */
    balanceFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    balanceLineHeight: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    balanceColor: _propTypes["default"].string,

    /**
     * @default palette.twSemi
     */
    balanceFontWeight: _propTypes["default"].number,

    /**
     * @default palette.tAccent
     */
    selectedBalanceColor: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    numberColor: _propTypes["default"].string,

    /**
     * @default palette.twNormal
     */
    numberFontWeight: _propTypes["default"].number,

    /**
     * @default palette.tAccent
     */
    selectedNumberColor: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    nameColor: _propTypes["default"].string,

    /**
     * @default palette.twNormal
     */
    nameFontWeight: _propTypes["default"].number,

    /**
     * @default palette.tAccent
     */
    selectedNameColor: _propTypes["default"].string,

    /**
     * @default palette.tsNormal
     */
    currencyFontSize: _propTypes["default"].string,

    /**
     * @default palette.tlNormal
     */
    currencyLineHeight: _propTypes["default"].string,

    /**
     * @default palette.tFilled
     */
    currencyColor: _propTypes["default"].string,

    /**
     * @default palette.twSemi
     */
    currencyFontWeight: _propTypes["default"].number,

    /**
     * @default palette.tAccent
     */
    selectedCurrencyColor: _propTypes["default"].string,

    /**
     * @default auto
     */
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @default auto
     */
    minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

    /**
     * @description simple shape
     */
    simple: _propTypes["default"].shape({
      /**
       * @default palette
       */
      palette: _propTypes["default"].object,

      /**
       * @default flex
       */
      display: _propTypes["default"].string,

      /**
       * @default palette.tsNormal
       */
      fontSize: _propTypes["default"].string,

      /**
       * @default palette.tlNormal
       */
      lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.tFilled
       */
      color: _propTypes["default"].string,

      /**
       * @default palette.tDisabled
       */
      disabledColor: _propTypes["default"].string,

      /**
       * @default palette.twNormal
       */
      fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.tAccent
       */
      selectedColor: _propTypes["default"].string,

      /**
       * @default palette.tFilled
       */
      balanceColor: _propTypes["default"].string,

      /**
       * @default palette.twSemi
       */
      balanceFontWeight: _propTypes["default"].number,

      /**
       * @default palette.tAccent
       */
      selectedBalanceColor: _propTypes["default"].string,

      /**
       * @default palette.tInactive
       */
      numberColor: _propTypes["default"].string,

      /**
       * @default palette.twNormal
       */
      numberFontWeight: _propTypes["default"].number,

      /**
       * @default palette.tAccent
       */
      selectedNumberColor: _propTypes["default"].string,

      /**
       * @default palette.tFilled
       */
      nameColor: _propTypes["default"].string,

      /**
       * @default palette.twNormal
       */
      nameFontWeight: _propTypes["default"].number,

      /**
       * @default palette.tAccent
       */
      selectedNameColor: _propTypes["default"].string,

      /**
       * @default palette.tFilled
       */
      currencyColor: _propTypes["default"].string,

      /**
       * @default palette.twSemi
       */
      currencyFontWeight: _propTypes["default"].number,

      /**
       * @default palette.tAccent
       */
      selectedCurrencyColor: _propTypes["default"].string,

      /**
       * @default auto
       */
      width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default auto
       */
      minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
    })
  })
};
CardSelect.defaultProps = {
  placeholder: 'CARD_SELECT_CARD_PLACEHOLDER',
  emptyListPlaceholder: 'CARD_SELECT_CARD_EMPTY_PLACEHOLDER',
  selectFirst: false,
  render: _cardRender["default"],
  simple: false
};
var _default = CardSelect;
exports["default"] = _default;